import * as React from "react"
import { VStack, Button, Box, Text } from "@chakra-ui/react"
import { useForm } from "react-hook-form"
import { useMutation } from "react-query"
import { Link, useNavigate } from "react-router-dom"

import { ReactComponent as Logo } from "../assets/images/logo.svg"
import { Form } from "../components/Form"
import { Input } from "../components/Input"
import { fetcher } from "../lib/fetcher"
import { useToast } from "../lib/hooks/useToast"
import { useDocumentTitle } from "../lib/hooks/useDocumentTitle"

export const ForgotPassword = () => {
  useDocumentTitle("Forgot password")

  const toast = useToast()
  const navigate = useNavigate()
  const defaultValues = { email: "" }
  const form = useForm({ defaultValues })

  const { mutateAsync: forgotPassword, isLoading } = useMutation<
    typeof defaultValues,
    unknown,
    typeof defaultValues
  >((data) => fetcher("password/forgot/", { body: JSON.stringify(data), method: "post" }))
  const handleSubmit = async (data: typeof defaultValues) => {
    try {
      await forgotPassword(data)
    } catch {
    } finally {
      toast({
        title: "Instructions sent!",
        description:
          "If we found an account associated with that email address, you will find an email from us in your inbox shortly.",
      })
      navigate("/")
    }
  }

  return (
    <VStack spacing={6}>
      <VStack spacing={4}>
        <Box as={Logo} h={50} fill="gray.700" />
        <Text color="gray.700">Forgot your password?</Text>
        <Text color="gray.500">Enter your email below to receive your password reset instructions.</Text>
      </VStack>
      <Form {...form} onSubmit={handleSubmit}>
        <Input name="email" placeholder="Email" />
        <Button width="100%" colorScheme="green" type="submit" isDisabled={isLoading} isLoading={isLoading}>
          Send instructions
        </Button>
        <Link to="/">Login</Link>
      </Form>
    </VStack>
  )
}
